export enum ConsentAcknowledgmentType {
  PERSONAL_INFO = 0,
  AXXELIST_ESTATE_FEE = 1
}